<template>
	<form v-if="settings" @submit.prevent="saveSettings">
		<div class="gh-layout">
			<aside class="gh-intro">
				<h2 class="gh-intro__title">General Settings</h2>
				<p class="gh-intro__desc">General settings of the application — name and background sync intervals.</p>
			</aside>

			<section class="gh-accounts">
				<div class="ada-card">
					<div class="gh-field">
						<label>Application Name</label>
						<input type="text" v-model="settings.applicationName" class="form-control" />
					</div>
					<div class="gh-field">
						<label>How often to check is there updates for contacts?</label>
						<select
							@change="changeCronString('contactsCheckInterval')"
							class="form-select"
							v-model="settings.contactsCheckInterval"
						>
							<option value="">Do not check</option>
							<option value="hourly">Every hour (once in an hour)</option>
							<option value="daily">Every day (once per day)</option>
							<option value="weekly">Every week (once per week)</option>
							<option value="monthly">Every month (once per month)</option>
						</select>
					</div>
				</div>
			</section>
		</div>

		<hr class="gh-divider" />

		<div class="gh-save-row">
			<button class="gh-save-btn" type="submit">
				<i class="fas fa-save"></i>
				Save changes
			</button>
		</div>
	</form>
</template>

<script>
import restApi from '../../api/index.js'
import { handleErrors } from '../../actions/helpers'
export default {
	name: 'General',
	data() {
		return {
			name: 'generalSettings',
			type: 'settings',
			settings: {
				contactsCheckInterval: 'hourly',
				contactsCheckIntervalString: '0 0 * * *',
				applicationName: '',
			},
		}
	},
	created() {
		this.getSettings()
	},
	methods: {
		getSettings() {
			restApi
				.get('/settings', { params: { name: this.name, type: this.type } })
				.then(({ data }) => {
					if (data) {
						this.settings = JSON.parse(data.data)
					}
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},
		saveSettings() {
			restApi
				.post('/settings', {
					name: this.name,
					type: this.type,
					data: JSON.stringify(this.settings),
				})
				.then(({ data }) => {
					data.data = JSON.parse(data.data)
					this.settings = data.data
					this.$swal.fire({
						icon: 'success',
						title: 'Settings successfully saved!',
						timer: 4000,
					})
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		changeCronString(period) {
			if (this.settings[period] === 'hourly') {
				this.settings[period + 'String'] = '0 * * * *'
			}
			if (this.settings[period] === 'daily') {
				this.settings[period + 'String'] = '0 0 * * *'
			}
			if (this.settings[period] === 'weekly') {
				this.settings[period + 'String'] = '0 0 * * 0'
			}
			if (this.settings[period] === 'monthly') {
				this.settings[period + 'String'] = '0 0 1 * *'
			}
		},
	},
}
</script>
